import { render } from "./ListaUsuario.vue?vue&type=template&id=dc85f05a&scoped=true"
import script from "./ListaUsuario.vue?vue&type=script&lang=js"
export * from "./ListaUsuario.vue?vue&type=script&lang=js"

import "./ListaUsuario.vue?vue&type=style&index=0&id=dc85f05a&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc85f05a"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QSelect,QBtn,QTabs,QTab,QTabPanel,QField});
